import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';

export default defineModule({
    id: 'transaction',
    routes: [
        {
            path: '/transaction-record',
            name: 'txRecord',
            meta: { requiresAuth: true },
            component: overridable('TransactionRecordPage', () => import(/* webpackChunkName: "transaction" */ './views/TransactionRecordPage.vue'))
        },
        {
            path: '/game-report',
            name: 'gameReport',
            meta: { requiresAuth: true },
            component: overridable('GameReportPage', () => import(/* webpackChunkName: "transaction" */ './views/GameReportPage.vue'))
        },
        {
            path: '/game-report/detail',
            name: 'gameReportDetail',
            meta: { requiresAuth: true },
            component: overridable('GameReportDetailPage', () => import(/* webpackChunkName: "transaction" */ './views/GameReportDetailPage.vue'))
        }
    ],
    contributes: {
        'nav.menu': [
            { key: 'transactionRecord', order: 30, label: 'nav.transactionRecord', to: '/transaction-record' },
            { key: 'gameReport', order: 31, label: 'nav.gameReport', to: '/game-report' }
        ]
    }
});
